/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IEspecialty } from 'app/shared/model/especialty.model';
import { ISymptom } from 'app/shared/model/symptom.model';
import { IChronicCondition } from 'app/shared/model/chronic-condition.model';

export interface ISpecialitySymptomPreferences {
  id?: string;
  active?: boolean | null;
  draft?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  aSymptom?: boolean | null;
  aCondition?: boolean | null;
  speciality?: IEspecialty | null;
  symptom?: ISymptom | null;
  condition?: IChronicCondition | null;
}

export const defaultValue: Readonly<ISpecialitySymptomPreferences> = {
  active: false,
  draft: false,
  aSymptom: false,
  aCondition: false,
};
